import { _js } from '@ifixit/utils/localize';
import { faCode } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const CodeButton = () => {
   const { editor } = useEditorContext();

   if (editor.isDestroyed) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleCode().run()}
         isActive={editor.isActive('code')}
         isDisabled={!editor.can().toggleCode()}
         icon={<FontAwesomeIcon icon={faCode} />}
         /* Translators: "Code" as in monospaced font */
         title={_js('Insert code')}
         shortcut={'e'}
      />
   );
};
